module.exports = __webpack_public_path__ + "img/personel-bkg.png";